import { render } from "./EditStory.vue?vue&type=template&id=a7aca7e8&lang=html"
import script from "./EditStory.vue?vue&type=script&lang=js"
export * from "./EditStory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__